import React from 'react';

import { TextSkeleton } from '../../common/skeletons/typography';
import CardSkeleton from '../CardSkeleton';
import { FlexGrow, RowHeader, RowHeaderWrapper } from '../styled';

import { ProductContainer } from './styled';

export interface CardRowSkeletonProps {
  cardsNum: number;
}

const CardRowSkeleton = ({ cardsNum }: CardRowSkeletonProps) => {
  const visibleCards = new Array(cardsNum).fill(0).map((_, i) => <CardSkeleton key={`${i}`} />);

  return (
    <React.Fragment>
      <RowHeaderWrapper>
        <RowHeader>
          <TextSkeleton width="108px">&nbsp;</TextSkeleton>
        </RowHeader>

        <FlexGrow />
      </RowHeaderWrapper>

      <ProductContainer>{visibleCards}</ProductContainer>
    </React.Fragment>
  );
};

export default CardRowSkeleton;
